// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { HostService } from '../_generated/host.service';
import {
  DeleteSiteRequestInterface,
  DeleteSitesResponseInterface,
  GetHealthCheckRequestInterface,
  GetHealthCheckResponseInterface,
  GetDiscrepancyDataRequestInterface,
  GetDiscrepancyDataResponseInterface,
  GetMultiSiteRequestInterface,
  GetMultiSiteResponseInterface,
  GetPluginUpdatesCountRequestInterface,
  GetPluginUpdatesCountResponseInterface,
  GetSiteRequestInterface,
  GetSiteResponseInterface,
  SearchPidHealthRequestInterface,
  SearchPidHealthResponseInterface,
  SearchRequestInterface,
  SearchResponseInterface,
} from './interfaces/';
import {
  DeleteSiteRequest,
  DeleteSitesResponse,
  GetDiscrepancyDataRequest,
  GetDiscrepancyDataResponse,
  GetHealthCheckRequest,
  GetHealthCheckResponse,
  GetMultiSiteRequest,
  GetMultiSiteResponse,
  GetPluginUpdatesCountRequest,
  GetPluginUpdatesCountResponse,
  GetSiteRequest,
  GetSiteResponse,
  SearchPidHealthRequest,
  SearchPidHealthResponse,
  SearchRequest,
  SearchResponse,
} from './objects/';

@Injectable({ providedIn: 'root' })
export class SearchApiService {
  private _host = this.hostService.hostWithScheme;

  constructor(
    private http: HttpClient,
    private hostService: HostService,
  ) {}

  private apiOptions(): { headers: HttpHeaders; withCredentials: boolean } {
    return {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    };
  }

  search(r: SearchRequest | SearchRequestInterface): Observable<SearchResponse> {
    const request = (<SearchRequest>r).toApiJson ? <SearchRequest>r : new SearchRequest(r);
    return this.http
      .post<SearchResponseInterface>(
        this.hostService.hostWithScheme() + '/wsp_admin_center.v1.SearchService/Search',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(
        map((resp) => SearchResponse.fromProto(resp)),
        share(),
      );
  }

  getPluginUpdatesCount(
    r: GetPluginUpdatesCountRequest | GetPluginUpdatesCountRequestInterface,
  ): Observable<GetPluginUpdatesCountResponse> {
    const request = (<GetPluginUpdatesCountRequest>r).toApiJson
      ? <GetPluginUpdatesCountRequest>r
      : new GetPluginUpdatesCountRequest(r);
    return this.http
      .post<GetPluginUpdatesCountResponseInterface>(
        this.hostService.hostWithScheme() + '/wsp_admin_center.v1.SearchService/GetPluginUpdatesCount',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(
        map((resp) => GetPluginUpdatesCountResponse.fromProto(resp)),
        share(),
      );
  }

  getSiteHealthChecks(r: GetHealthCheckRequest | GetHealthCheckRequestInterface): Observable<GetHealthCheckResponse> {
    const request = (<GetHealthCheckRequest>r).toApiJson ? <GetHealthCheckRequest>r : new GetHealthCheckRequest(r);
    return this.http
      .post<GetHealthCheckResponseInterface>(
        this.hostService.hostWithScheme() + '/wsp_admin_center.v1.SearchService/GetSiteHealthChecks',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(map((resp) => GetHealthCheckResponse.fromProto(resp)));
  }
  getPidHealthData(r: SearchPidHealthRequest | SearchPidHealthRequestInterface): Observable<SearchPidHealthResponse> {
    const request = (<SearchPidHealthRequest>r).toApiJson ? <SearchPidHealthRequest>r : new SearchPidHealthRequest(r);
    return this.http
      .post<SearchPidHealthResponseInterface>(
        this.hostService.hostWithScheme() + '/wsp_admin_center.v1.SearchService/GetPidHealthData',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(map((resp) => SearchPidHealthResponse.fromProto(resp)));
  }
  getDiscrepancyData(
    r: GetDiscrepancyDataRequest | GetDiscrepancyDataRequestInterface,
  ): Observable<GetDiscrepancyDataResponse> {
    const request = (<GetDiscrepancyDataRequest>r).toApiJson
      ? <GetDiscrepancyDataRequest>r
      : new GetDiscrepancyDataRequest(r);
    return this.http
      .post<GetDiscrepancyDataResponseInterface>(
        this._host + '/wsp_admin_center.v1.SearchService/GetDiscrepancyData',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(map((resp) => GetDiscrepancyDataResponse.fromProto(resp)));
  }
  getSite(r: GetSiteRequest | GetSiteRequestInterface): Observable<GetSiteResponse> {
    const request = (<GetSiteRequest>r).toApiJson ? <GetSiteRequest>r : new GetSiteRequest(r);
    return this.http
      .post<GetSiteResponseInterface>(
        this._host + '/wsp_admin_center.v1.SearchService/GetSite',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(map((resp) => GetSiteResponse.fromProto(resp)));
  }
  getMultiSite(r: GetMultiSiteRequest | GetMultiSiteRequestInterface): Observable<GetMultiSiteResponse> {
    const request = (<GetMultiSiteRequest>r).toApiJson ? <GetMultiSiteRequest>r : new GetMultiSiteRequest(r);
    return this.http
      .post<GetMultiSiteResponseInterface>(
        this._host + '/wsp_admin_center.v1.SearchService/GetMultiSite',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(map((resp) => GetMultiSiteResponse.fromProto(resp)));
  }
  deleteSitesInAdminCenter(r: DeleteSiteRequest | DeleteSiteRequestInterface): Observable<DeleteSitesResponse> {
    const request = (<DeleteSiteRequest>r).toApiJson ? <DeleteSiteRequest>r : new DeleteSiteRequest(r);
    return this.http
      .post<DeleteSitesResponseInterface>(
        this._host + '/wsp_admin_center.v1.SearchService/DeleteSitesInAdminCenter',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(map((resp) => DeleteSitesResponse.fromProto(resp)));
  }
}
